export default __webpack_public_path__ + "static/media/image5.1de81643.jpg";